import React from 'react'
import { useAuth } from '../../shared/contexts/AuthContext'

export const SessionDebugger: React.FC = () => {
  const { session, user, signOut } = useAuth()

  const handleClearSession = () => {
    // Clear all storage and reload
    localStorage.clear()
    sessionStorage.clear()
    window.location.reload()
  }

  const handleSignOut = async () => {
    await signOut()
  }

  const handleHardRefresh = () => {
    // Clear all storage
    localStorage.clear()
    sessionStorage.clear()
    
    // Clear specific Supabase tokens
    localStorage.removeItem('sb-iasrrcndbdelwetoljkp-auth-token')
    localStorage.removeItem('supabase.auth.token')
    localStorage.removeItem('supabase.auth.refreshToken')
    localStorage.removeItem('supabase.auth.expiresAt')
    localStorage.removeItem('supabase.auth.expiresIn')
    localStorage.removeItem('supabase.auth.tokenType')
    
    // Force hard refresh
    window.location.reload()
  }

  return (
    <div className="fixed bottom-4 right-4 bg-gray-800 text-white p-4 rounded-lg shadow-lg z-50">
      <h3 className="text-sm font-bold mb-2">Session Debugger</h3>
      <div className="text-xs space-y-1 mb-3">
        <div>Session: {session ? '✅ Active' : '❌ None'}</div>
        <div>User: {user ? `✅ ${user.email}` : '❌ None'}</div>
        <div>User ID: {user?.id || 'None'}</div>
      </div>
      <div className="space-y-2">
        <button
          onClick={handleClearSession}
          className="w-full px-2 py-1 text-xs bg-yellow-600 hover:bg-yellow-700 rounded"
        >
          Clear Session
        </button>
        <button
          onClick={handleSignOut}
          className="w-full px-2 py-1 text-xs bg-red-600 hover:bg-red-700 rounded"
        >
          Sign Out
        </button>
        <button
          onClick={handleHardRefresh}
          className="w-full px-2 py-1 text-xs bg-blue-600 hover:bg-blue-700 rounded"
        >
          Hard Refresh
        </button>
      </div>
    </div>
  )
} 